export enum facadeType {
    wood = 'wood',
    tiles = 'tiles',
}